<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--small">
        <h1 class="content__title">Clientes</h1>
        <div class="results" v-if="customers">
          <div class="results__element" v-for="(customer, index) in customers" :key="index">
            <div class="results__info">
              <h2 class="results__title" v-text="customer.name"></h2>
            </div>
            <div class="results__actions">
              <router-link :to="{name: 'customerView', params: {id: customer.id}}" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
export default {
  mixins: [
    httpService
  ],
  data: function () {
    return {
      customers: null
    }
  },
  created: function () {
    this.getCustomers()
  },
  methods: {
    getCustomers: function () {
      let httpRequest = {
        params: '?fields=name,id',
        module: 'customers'
      }
      this.get(httpRequest)
        .then(
          customers => {
            this.customers = customers.data
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/components/_home"
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue